import {TeaserEntry} from "../helper/interfaces";
import TeaserMinimizedContainerNN from "./teaserMinimizedContainerNN";
interface TeaserInArticleNNProps {
  teaser: TeaserEntry,
  className?: string,
  navigate?: (id?: string, ressortId?: string) => void,
}

const TeaserInArticleNN = ({
  teaser,
  className
}: TeaserInArticleNNProps) => {
  const classNames = ['teaser-in-article']

  if (className) classNames.push(className)

  return (
    <div className={classNames.join(' ')}>
      <TeaserMinimizedContainerNN teaser={teaser} showImage={true} showResorts={true}  isAlreadyLinked={true} />
    </div>
  )
}

export default TeaserInArticleNN